import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useDtpModel } from "../dtpModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { IDtpDetail } from "../dtpTypes";
import { momentFormat } from "@/utils/utils";


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys,
    } = useDtpModel();
    const { getTreeNodeName } = useDictModel(() => []);

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<IDtpDetail> = [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '外贸合同号',
            width: 160,
            dataIndex: 'saleRealCode',
            fixed: "left",
        }, {
            title: '运输单据号',
            width: 120,
            dataIndex: 'code',
        }, {
            title: '状态',
            width: 120,
            dataIndex: 'status',
            render: text => getTreeNodeName(text)
        }, {
            title: '收货人',
            width: 160,
            dataIndex: 'customerName',
            render: text => <p className="ellipsis" title={text}>{text}</p>
        }, {
            title: '贸易国别',
            width: 120,
            dataIndex: 'country',
            render: text => getTreeNodeName(text)
        }, {
            title: '运输方式',
            width: 100,
            dataIndex: "transportMode",
            render: text => getTreeNodeName(text)
        }, {
            title: '托运日期',
            width: 180,
            dataIndex: "consignTime",
            render: text => momentFormat(text, "YYYY-MM-DD")
        }, {
            title: '装货港',
            width: 180,
            dataIndex: "shipment",
            render: text => getTreeNodeName(text)
        }, {
            title: '卸货港',
            width: 180,
            dataIndex: "discharge",
            render: text => getTreeNodeName(text)
        }, {
            title: '创建时间',
            width: 180,
            dataIndex: "createTime",
            render: t => momentFormat(t, "YYYY-MM-DD")

        }, {
            title: '创建人',
            width: 180,
            dataIndex: "createUser"
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
            render: text => <p className="ellipsis" title={text}>{text}</p>
        },
    ];


    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            rowKey={record => record.code}
            loading={loading}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.code);
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.code),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.code),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.code]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}
